import React, { useState } from "react";
import PropTypes from "prop-types";
import Expandable from "src/react/components/expandable";
import styled from "styled-components";
import { color } from "src/styles/variables";
import Markdown from "markdown-to-jsx";
import Tracking from "src/react/components/tracking";

function FaqItem({ subtitle, content, id }) {
  const [isOpened, setIsOpened] = useState(false);
  const handleOnClick = () => {
    setIsOpened(!isOpened);
  };

  if (!subtitle || !content) {
    return null;
  }

  return (
    <div>
      <Tracking
        tracking={!isOpened ? "custom" : ""}
        trackingOptions={{ location: "faq" }}
      >
        <FaqSubtitle
          data-selector="FaqSubtitle"
          id={`FaqSubtitle-${id}`}
          aria-controls={`FaqContent-${id}`}
          aria-expanded={isOpened}
          isOpened={isOpened}
          onClick={handleOnClick}
        >
          {subtitle}
        </FaqSubtitle>
      </Tracking>
      <Expandable isOpened={isOpened}>
        <FaqContent
          data-selector="FaqContent"
          id={`FaqContent-${id}`}
          aria-labelledby={`FaqSubtitle-${id}`}
        >
          <Markdown>{content}</Markdown>
        </FaqContent>
      </Expandable>
    </div>
  );
}

FaqItem.propTypes = {
  id: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};

export default FaqItem;

export const FaqSubtitle = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  font-size: 16px;
  font-family: inherit;
  border: none;
  border-radius: 5px;
  outline: none;
  position: relative;
  padding: 15px 35px 15px 15px;
  margin-bottom: 10px;
  background-color: ${({ isOpened }) =>
    isOpened ? color.dustyGrey : color.shipGrey};
  cursor: pointer;
  font-weight: 400;
  color: ${color.grey};
  transition: background-color .3s, color .3s;
  :focus {
    background-color: ${color.dustyGrey};
  }
  :after {
    content: '${({ isOpened }) => (isOpened ? "\uFF0D" : "\uFF0B")}';
    font-size: 18px;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
  @media (min-width: 600px) {
    padding: 20px 40px 20px 20px;
    :after {
      right: 20px;
    }
  }
`;

const FaqContent = styled.div`
  padding: 10px 20px 20px;
  ul {
    list-style: disc;
    padding-left: 17px;
  }
  li {
    margin-bottom: 10px;
  }
`;
